export const TRANSACTION_HISTORY_TABS = {
  WITHDRAWAL: 'withdrawal',
  REWARD_TRANSACTION: 'rewardTransaction',
};
